export default class Backend {
  async init() {
    const config = await fetch("/config.json").then((r) => r.json());
    const host = window.location.hostname;
    const domainConfig = config[host] || config["localhost"];

    this.api_link = domainConfig.API_BASE_URL;
    this.EntryKey = domainConfig.ENTRYKEY;

    return this; // allow chaining
  }

  update(data) {
    return fetch(this.api_link + "/update", {
      method: "POST",
      headers: {
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  server(data) {
    return fetch(this.api_link + "/find_server", {
      method: "POST",
      headers: {
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  demo(data) {
    return fetch(this.api_link + "/demo", {
      method: "POST",
      headers: {
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  login(data) {
    return fetch(this.api_link + "/login", {
      method: "POST",
      headers: {
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  register(data) {
    return fetch(this.api_link + "/register", {
      method: "POST",
      headers: {
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  cpassword(data) {
    return fetch(this.api_link + "/cpassword", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  chnagepassword(data) {
    return fetch(this.api_link + "/chnagepassword", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  check_user(data) {
    return fetch(this.api_link + "/check_user", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  drate(data) {
    return fetch(this.api_link + "/drate", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  update_drate(data) {
    return fetch(this.api_link + "/update_drate", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  index(data) {
    return fetch(this.api_link + "/index", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  marquee(data) {
    return fetch(this.api_link + "/marquee", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  update_marquee(data) {
    return fetch(this.api_link + "/update_marquee", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }

  load_symbol(data) {
    return fetch(this.api_link + "/load_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        username: data.username,
        token: data.token,
        id: data.id,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }

  home(data) {
    return fetch(this.api_link + "/home", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  watchlist(data) {
    return fetch(this.api_link + "/load_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  all_symbol(data) {
    return fetch(this.api_link + "/all_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  find_symbol(data) {
    return fetch(this.api_link + "/find_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  add_symbol(data) {
    return fetch(this.api_link + "/add_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  delete_symbol(data) {
    return fetch(this.api_link + "/delete_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  edit_symbol(data) {
    return fetch(this.api_link + "/edit_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  edit_symbol_main(data) {
    return fetch(this.api_link + "/edit_symbol_main", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  symbol_qty(data) {
    return fetch(this.api_link + "/symbol_qty", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  edit_symbol_qty(data) {
    return fetch(this.api_link + "/edit_symbol_qty", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  reset_symbol(data) {
    return fetch(this.api_link + "/reset_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  block_symbol(data) {
    return fetch(this.api_link + "/block_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  allow_symbol(data) {
    return fetch(this.api_link + "/allow_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  symbol_standing(data) {
    return fetch(this.api_link + "/symbol_standing", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  buy_sell(data) {
    return fetch(this.api_link + "/buy_sell", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  sq_single(data) {
    return fetch(this.api_link + "/sq_single", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  sq_all(data) {
    return fetch(this.api_link + "/sq_all", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  mtrade(data) {
    return fetch(this.api_link + "/mtrade", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  mtrade_client(data) {
    return fetch(this.api_link + "/mtrade_client", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  rollover(data) {
    return fetch(this.api_link + "/rollover", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  sq_all_master(data) {
    return fetch(this.api_link + "/sq_all_master", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  sq_all_super(data) {
    return fetch(this.api_link + "/sq_all_super", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  sq_all_admin(data) {
    return fetch(this.api_link + "/sq_all_admin", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  standing(data) {
    return fetch(this.api_link + "/load_standing", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  standing_admin(data) {
    return fetch(this.api_link + "/load_standing_admin", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  standing_super(data) {
    return fetch(this.api_link + "/load_standing_super", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  standing_master(data) {
    return fetch(this.api_link + "/load_standing_master", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  standing_broker(data) {
    return fetch(this.api_link + "/load_standing_broker", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  pending(data) {
    return fetch(this.api_link + "/load_pending", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_pending_admin(data) {
    return fetch(this.api_link + "/load_pending_admin", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_pending_super(data) {
    return fetch(this.api_link + "/load_pending_super", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_pending_master(data) {
    return fetch(this.api_link + "/load_pending_master", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_pending_broker(data) {
    return fetch(this.api_link + "/load_pending_broker", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  delete_pending(data) {
    return fetch(this.api_link + "/delete_pending", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  trade(data) {
    return fetch(this.api_link + "/load_trade", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  trade_admin(data) {
    return fetch(this.api_link + "/load_trade_admin", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  trade_super(data) {
    return fetch(this.api_link + "/load_trade_super", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  trade_master(data) {
    return fetch(this.api_link + "/load_trade_master", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  trade_broker(data) {
    return fetch(this.api_link + "/load_trade_broker", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }

  holding_admin(data) {
    return fetch(this.api_link + "/holding_admin", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  holding_super(data) {
    return fetch(this.api_link + "/holding_super", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }

  holding_master(data) {
    return fetch(this.api_link + "/holding_master", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }

  holding_broker(data) {
    return fetch(this.api_link + "/holding_broker", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  symbol_rejection(data) {
    return fetch(this.api_link + "/symbol_rejection", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  symbol_rejection_master(data) {
    return fetch(this.api_link + "/symbol_rejection_master", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  symbol_qty_list(data) {
    return fetch(this.api_link + "/symbol_qty_list", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  rules(data) {
    return fetch(this.api_link + "/rules", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  add_rules(data) {
    return fetch(this.api_link + "/add_rules", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  delete_rules(data) {
    return fetch(this.api_link + "/delete_rules", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  message(data) {
    return fetch(this.api_link + "/message", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  delete_message(data) {
    return fetch(this.api_link + "/delete_message", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  add_message(data) {
    return fetch(this.api_link + "/add_message", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  loginhistory(data) {
    return fetch(this.api_link + "/load_login_history", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  info(data) {
    return fetch(this.api_link + "/info", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  add_bank_account(data) {
    return fetch(this.api_link + "/add_bank_account", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_bank_account(data) {
    return fetch(this.api_link + "/load_bank_account", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  update_bank_account(data) {
    return fetch(this.api_link + "/update_bank_account", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  bank_account(data) {
    return fetch(this.api_link + "/bank_account", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  upload_payment_amount_ss(data, data2) {
    return fetch(this.api_link + "/upload_payment_amount_ss", {
      method: "POST",
      headers: {
        server: data2.server,
        token: data2.token,
        id: data2.id,
        username: data2.username,
        amount: data2.amount,
        bank_id: data2.bank_id,
        utr: data2.utr,
        EntryKey: this.EntryKey,
      },
      body: data,
    }).then((response) => response.json());
  }
  update_deposit_status(data) {
    return fetch(this.api_link + "/update_deposit_status", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  update_withdrawal_status(data) {
    return fetch(this.api_link + "/update_withdrawal_status", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  withdrawal(data) {
    return fetch(this.api_link + "/withdrawal", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  transaction(data) {
    return fetch(this.api_link + "/transaction", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  payin(data) {
    const formData = new FormData();
    formData.append("server", data.server);
    formData.append("token", data.token);
    formData.append("id", data.id);
    formData.append("username", data.username);
    formData.append("EntryKey", this.EntryKey);
    formData.append("amount", data.amount);
    if (data.image) {
      formData.append("image", data.image);
    }

    return fetch(this.api_link + "/payin", {
      method: "POST",
      headers: {
        // Don't set 'Content-Type' manually when using FormData
        accept: "application/json",
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
      },
      body: formData,
    }).then((response) => response.json());
  }
  payout(data) {
    return fetch(this.api_link + "/payout", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  profile(data) {
    return fetch(this.api_link + "/profile", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  deleteaccount(data) {
    return fetch(this.api_link + "/deleteaccount", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  settlement(data) {
    return fetch(this.api_link + "/settlement", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  settlement_admin(data) {
    return fetch(this.api_link + "/settlement_admin", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  settlement_super(data) {
    return fetch(this.api_link + "/settlement_super", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  settlement_master(data) {
    return fetch(this.api_link + "/settlement_master", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  settlement_broker(data) {
    return fetch(this.api_link + "/settlement_broker", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  profit_loss(data) {
    return fetch(this.api_link + "/profit_loss", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  profit_loss_admin(data) {
    return fetch(this.api_link + "/profit_loss_admin", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  profit_loss_super(data) {
    return fetch(this.api_link + "/profit_loss_super", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  profit_loss_master(data) {
    return fetch(this.api_link + "/profit_loss_master", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  profit_loss_broker(data) {
    return fetch(this.api_link + "/profit_loss_broker", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  delete_account(data) {
    return fetch(this.api_link + "/delete_account", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  user_report(data) {
    return fetch(this.api_link + "/user_report", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  generatepdf(data) {
    return fetch(this.api_link + "/generatepdf", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  user_filter(data) {
    return fetch(this.api_link + "/load_user_filter", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  user_filter_bill(data) {
    return fetch(this.api_link + "/load_user_filter_bill", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  broker_filter_bill(data) {
    return fetch(this.api_link + "/load_broker_filter_bill", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  interest_bill(data) {
    return fetch(this.api_link + "/interest_bill", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_super(data) {
    return fetch(this.api_link + "/load_super", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_master(data) {
    return fetch(this.api_link + "/load_master", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_user(data) {
    return fetch(this.api_link + "/load_user", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_user_select(data) {
    return fetch(this.api_link + "/load_user_select", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  update_status(data) {
    return fetch(this.api_link + "/update_status", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_status(data) {
    return fetch(this.api_link + "/load_status", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  create_super(data) {
    return fetch(this.api_link + "/create_super", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  create_master(data) {
    return fetch(this.api_link + "/create_master", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  create_user(data) {
    return fetch(this.api_link + "/create_user", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_summary_super(data) {
    return fetch(this.api_link + "/load_summary_super", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_summary_master(data) {
    return fetch(this.api_link + "/load_summary_master", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_summary_broker(data) {
    return fetch(this.api_link + "/load_summary_broker", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_summary(data) {
    return fetch(this.api_link + "/load_summary", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  edit_user_details(data) {
    return fetch(this.api_link + "/edit_user_details", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  edit_user_margin(data) {
    return fetch(this.api_link + "/edit_user_margin", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  edit_user_limit(data) {
    return fetch(this.api_link + "/edit_user_limit", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  edit_user_multiple(data) {
    return fetch(this.api_link + "/edit_user_multiple", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  edit_user_margin_level(data) {
    return fetch(this.api_link + "/edit_user_margin_level", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  edit_user_commission(data) {
    return fetch(this.api_link + "/edit_user_commission", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  edit_user_commission_new(data) {
    return fetch(this.api_link + "/edit_user_commission_new", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  edit_user_deposit(data) {
    return fetch(this.api_link + "/edit_user_deposit", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  createdpdf(data) {
    return fetch(this.api_link + "/generatepdf", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  create_broker(data) {
    return fetch(this.api_link + "/create_broker", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_broker(data) {
    return fetch(this.api_link + "/load_broker", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_broker_user(data) {
    return fetch(this.api_link + "/load_broker_user", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  update_broker(data) {
    return fetch(this.api_link + "/update_broker", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  edit_broker_sharing(data) {
    return fetch(this.api_link + "/edit_broker_sharing", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  remove_broker(data) {
    return fetch(this.api_link + "/remove_broker", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  load_ledger(data) {
    return fetch(this.api_link + "/load_ledger", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  chnage_symbol_grp(data) {
    return fetch(this.api_link + "/chnage_symbol_grp", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  reset_password(data) {
    return fetch(this.api_link + "/reset_password", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  limit_p(data) {
    return fetch(this.api_link + "/limit_p", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  pl_limit(data) {
    return fetch(this.api_link + "/pl_limit", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  s_limit(data) {
    return fetch(this.api_link + "/s_limit", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  min_rate(data) {
    return fetch(this.api_link + "/min_rate", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  total_mcx_lot(data) {
    return fetch(this.api_link + "/total_mcx_lot", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  sq_time(data) {
    return fetch(this.api_link + "/sq_time", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  delete(data) {
    return fetch(this.api_link + "/delete", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }

  add_nse(data) {
    return fetch(this.api_link + "/add_nse", {
      method: "POST",
      headers: {
        server: data.server,
        username: data.username,
        token: data.token,
        id: data.id,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }

  add_mcx(data) {
    return fetch(this.api_link + "/add_mcx", {
      method: "POST",
      headers: {
        server: data.server,
        username: data.username,
        token: data.token,
        id: data.id,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }

  add_options(data) {
    return fetch(this.api_link + "/add_options", {
      method: "POST",
      headers: {
        server: data.server,
        username: data.username,
        token: data.token,
        id: data.id,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }

  update_symbol(data) {
    return fetch(this.api_link + "/update_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        username: data.username,
        token: data.token,
        id: data.id,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  closing_symbol(data) {
    return fetch(this.api_link + "/closing_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        username: data.username,
        token: data.token,
        id: data.id,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  expiry_symbol(data) {
    return fetch(this.api_link + "/expiry_symbol", {
      method: "POST",
      headers: {
        server: data.server,
        username: data.username,
        token: data.token,
        id: data.id,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  update_rate(data, formData) {
    return fetch(this.api_link + "/update_rate", {
      method: "POST",
      headers: {
        server: data.server,
        username: data.username,
        token: data.token,
        id: data.id,
        EntryKey: this.EntryKey
      },
      body: formData,
    }).then((response) => response.json());
  }

  copy_data(data) {
    return fetch(this.api_link + "/copy_data", {
      method: "POST",
      headers: {
        server: data.server,
        username: data.username,
        token: data.token,
        id: data.id,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  clear_data(data) {
    return fetch(this.api_link + "/clear_data", {
      method: "POST",
      headers: {
        server: data.server,
        username: data.username,
        token: data.token,
        id: data.id,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  reopen(data) {
    return fetch(this.api_link + "/reopen", {
      method: "POST",
      headers: {
        server: data.server,
        username: data.username,
        token: data.token,
        id: data.id,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  update_brokerage(data) {
    return fetch(this.api_link + "/update_brokerage", {
      method: "POST",
      headers: {
        server: data.server,
        username: data.username,
        token: data.token,
        id: data.id,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }

  logout(data) {
    return fetch(this.api_link + "/logout", {
      method: "POST",
      headers: {
        server: data.server,
        token: data.token,
        id: data.id,
        username: data.username,
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
}
